import Vue from 'vue'
import Vuex from 'vuex'

import user from './user.module'
import { clubs } from './clubs.module'
import { club } from './club.module'
import { clubRating } from './clubRating.module'
import { clubManagement } from './clubManagement.module'
import { clubTraining } from './clubTraining.module'
import { champs } from './champs.module'
import { alerts } from './alerts.module'
import { features } from './features.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    clubs,
    club,
    clubRating,
    clubManagement,
    clubTraining,
    champs,
    alerts,
    features
  }
})
